import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { ApiNode } from "types";
import { CategoriesAPI } from "api";

const queryKeys = {
  hierarchy: () => ["categories", "hierarchy"] as const,
};

/**
 * Fetches the category hierarchy
 */
export const useCategoryHierarchy = <T = ApiNode[]>(options: UseQueryOptions<ApiNode[], unknown, T> = {}) =>
  useQuery<ApiNode[], unknown, T>(queryKeys.hierarchy(), CategoriesAPI.hierarchy, options);
